import React from 'react'
import styles from './styles.module.scss'
import InviteMembers from 'srcReact/WorkplaceSettingsPage/components/InviteMembers'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Loader from 'srcReact/components/common2/Loader'
import LinkButton from 'srcReact/components/common2/LinkButton'

function InvitationStep(props) {
  const workplaceId = props.match.params.workplace_id
  const { t } = useTranslation()
  const {
    organization: {
      header: { user_properties, loaded }
    }
  } = useSelector((state) => state)

  return (
    <PageContainer pageClassName={styles.workplacePageWrapper} withFooter={false}>
      {loaded ? (
        <div className={styles.wrapper}>
          <h1 className={styles.title}>{t('workplace.invite_members.title_in_step')}</h1>
          {user_properties?.workplace?.with_member_invitation === 1 ? (
            <React.Fragment>
              <InviteMembers
                isWPCreationStep={true}
                className={styles.inviteMemberWrapper}
                selectedWorkplace={{ id: workplaceId }}
              />
              <LinkButton
                href={'/0/general_group_created'}
                size='medium'
                customStyle={styles.btnSkip}
                text={t('global.skip')}
              />
            </React.Fragment>
          ) : (
            <ErrorMessage text={t('account_settings.error_messages.noWPInvite')} center={true} />
          )}
        </div>
      ) : (
        <Loader />
      )}
    </PageContainer>
  )
}

export default InvitationStep
